"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));

var _bind2 = _interopRequireDefault(require("classnames/bind"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _withStyles = _interopRequireDefault(require("../utils/withStyles"));

var _breadcrumb = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("fundamental-styles/dist/breadcrumb.css") : void 0);

var classnames = (0, _bind.default)(_bind2.default).call(_bind2.default, _breadcrumb.default);

var BreadcrumbItem = function BreadcrumbItem(_ref) {
  var url = _ref.url,
      name = _ref.name,
      className = _ref.className,
      children = _ref.children,
      cssNamespace = _ref.cssNamespace,
      props = (0, _objectWithoutProperties2.default)(_ref, ["url", "name", "className", "children", "cssNamespace"]);

  var renderLink = function renderLink() {
    if (!children && url) {
      return /*#__PURE__*/_react.default.createElement("a", {
        className: classnames("".concat(cssNamespace, "-breadcrumb__link")),
        href: url
      }, name);
    } else if (children) {
      return /*#__PURE__*/_react.default.cloneElement(children, {
        'className': classnames("".concat(cssNamespace, "-breadcrumb__link"))
      });
    }
  };

  var breadcrumbItemClasses = classnames("".concat(cssNamespace, "-breadcrumb__item"), className);
  return /*#__PURE__*/_react.default.createElement("li", (0, _extends2.default)({}, props, {
    className: breadcrumbItemClasses
  }), renderLink());
};

BreadcrumbItem.displayName = 'Breadcrumb.Item';
process.env.NODE_ENV !== "production" ? BreadcrumbItem.propTypes = {
  /** Node(s) to render within the component */
  children: _propTypes.default.node,

  /** CSS class(es) to add to the element */
  className: _propTypes.default.string,

  /** Text for the internal anchor tag */
  name: _propTypes.default.string,

  /** An anchor tag will be generated and set to the url prop. Name or child text must be provided */
  url: _propTypes.default.string
} : void 0;

var _default = (0, _withStyles.default)(BreadcrumbItem);

exports.default = _default;